var _path, _line, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0957 9.83398H4.79883V15.4927H13.9863V9.83398H11.6895",
    stroke: "#444444"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.42773,
    y1: 4.84717,
    x2: 9.42773,
    y2: 12.8633,
    stroke: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72754 6.2876L9.39258 4.62256L11.0576 6.2876",
    stroke: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.0fbd27bfb60e4a347ee940f395ad637a.svg";
export { ForwardRef as ReactComponent };